import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.checklist.result');
import { OnInit, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare let WizRoute: any;
declare let wiz: any;

const GRADE_VALUES: any = { a: 10, b: 8, c: 5, d: 2, e: 0 };
const INSPECTION_CATEGORY_WEIGHTS: any = {
    '주요시설': 60,
    '일반시설': 20,
    '부대시설': 20,
};

type ExportBlobResult = { blob: Blob; filename: string };

@Component({
    selector: 'wiz-page-checklist-result',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.checklist.result/view.scss */
:host {
  display: block;
  height: 100vh;
  background-color: #F8F9FA;
}

.result-page {
  font-family: "Pretendard", sans-serif;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.header-container {
  background-color: #FFFFFF;
  padding: 8px 16px;
  border-bottom: 1px solid #E3E3E3;
  flex-shrink: 0;
  z-index: 10;
}

.top-app-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}
.top-app-bar .nav-btn {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #444746;
  cursor: pointer;
  flex-shrink: 0;
}
.top-app-bar .nav-btn:hover {
  background-color: #F1F3F4;
}
.top-app-bar .nav-btn i {
  font-size: 16px;
}

.header-title-area {
  flex: 1;
  min-width: 0;
}
.header-title-area .header-title {
  font-size: 16px;
  font-weight: 800;
  color: #1F1F1F;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.header-title-area .header-badges {
  display: flex;
  gap: 6px;
  margin-top: 2px;
  flex-wrap: wrap;
}
.header-title-area .badge {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
}
.header-title-area .badge.form-type {
  background-color: #D3E3FD;
  color: #041E49;
}
.header-title-area .badge.facility {
  background-color: #E6F4EA;
  color: #137333;
}
.header-title-area .badge.facility i {
  margin-right: 3px;
}
.header-title-area .badge.status.submitted {
  background-color: #E6F4EA;
  color: #137333;
}
.header-title-area .badge.status.submit-pending {
  background-color: #E8F0FE;
  color: #1A73E8;
}
.header-title-area .badge.status.sync-failed {
  background-color: #FCE8E6;
  color: #C5221F;
}
.header-title-area .badge.status.draft {
  background-color: #FEF7E0;
  color: #B05E00;
}
.header-title-area .badge.export-state.server-confirmed {
  background-color: #E6F4EA;
  color: #137333;
}
.header-title-area .badge.export-state.local-pending {
  background-color: #E8F0FE;
  color: #1A73E8;
}
.header-title-area .badge.export-state.local-failed {
  background-color: #FCE8E6;
  color: #C5221F;
}

.header-actions {
  flex-shrink: 0;
  display: flex;
  gap: 6px;
  align-items: center;
}
.header-actions .btn-action {
  height: 36px;
  padding: 0 14px;
  border-radius: 18px;
  border: none;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s;
}
.header-actions .btn-action i {
  font-size: 12px;
}
.header-actions .btn-action:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.header-actions .btn-export {
  background: #0B57D0;
  color: #fff;
}
.header-actions .btn-export:hover:not(:disabled) {
  background: #0947a9;
}
.header-actions .btn-sync-retry {
  background: #FEF7E0;
  color: #B05E00;
}
.header-actions .btn-sync-retry:hover:not(:disabled) {
  background: #FEEFC3;
}
.header-actions .btn-share {
  background: #E8F0FE;
  color: #0B57D0;
}
.header-actions .btn-share:hover:not(:disabled) {
  background: #D3E3FD;
}
.header-actions .btn-edit {
  height: 36px;
  padding: 0 14px;
  border-radius: 18px;
  border: none;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 700;
  background: #F1F3F4;
  color: #444746;
  cursor: pointer;
}
.header-actions .btn-edit:hover {
  background: #E3E3E3;
}
.header-actions .btn-edit i {
  font-size: 12px;
}

.respond-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.export-state-panel {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border-bottom: 1px solid #E8EAED;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
}
.export-state-panel.server-confirmed {
  background: #E6F4EA;
  color: #137333;
}
.export-state-panel.local-pending {
  background: #E8F0FE;
  color: #1A73E8;
}
.export-state-panel.local-failed {
  background: #FCE8E6;
  color: #C5221F;
}
.export-state-panel i {
  font-size: 14px;
}

.section-nav {
  display: flex;
  gap: 2px;
  padding: 8px 16px;
  background: #FFFFFF;
  border-bottom: 1px solid #E8EAED;
  overflow-x: auto;
  flex-shrink: 0;
}
.section-nav::-webkit-scrollbar {
  display: none;
}

.section-tab {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 8px;
  border: 1px solid transparent;
  background: transparent;
  font-size: 13px;
  font-weight: 600;
  color: #5F6368;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.15s;
}
.section-tab .tab-num {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #E8EAED;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 800;
}
.section-tab.active {
  background: #D3E3FD;
  border-color: #A8C7FA;
  color: #041E49;
}
.section-tab.active .tab-num {
  background: #0B57D0;
  color: #fff;
}
.section-tab:hover:not(.active) {
  background: #F1F3F4;
}

.section-content {
  flex: 1;
  overflow-y: auto;
  padding: 12px 16px;
}

.section-panel {
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}

.section-header {
  margin-bottom: 12px;
}
.section-header h3 {
  font-size: 17px;
  font-weight: 800;
  color: #1F1F1F;
  margin: 0 0 4px;
}
.section-header p {
  font-size: 13px;
  color: #5F6368;
  margin: 0;
}

.section-multipliers {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 10px;
  font-size: 12px;
  color: #5F6368;
}
.section-multipliers .mul {
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 700;
}
.section-multipliers .mul.good {
  background: #E6F4EA;
  color: #137333;
}
.section-multipliers .mul.fair {
  background: #FEF7E0;
  color: #B05E00;
}
.section-multipliers .mul.poor {
  background: #FCE8E6;
  color: #C5221F;
}

.inspection-table {
  width: 100%;
  border: 1px solid #DADCE0;
  border-radius: 8px;
  overflow: hidden;
}

.inspection-table .table-header {
  display: grid;
  grid-template-columns: 48px 1fr minmax(120px, 1fr) 100px 100px;
  background: #F1F3F4;
  border-bottom: 2px solid #DADCE0;
}
.inspection-table .table-header > div {
  padding: 10px 8px;
  font-size: 12px;
  font-weight: 800;
  color: #3C4043;
  text-align: center;
  border-right: 1px solid #DADCE0;
}
.inspection-table .table-header > div:last-child {
  border-right: none;
}
.inspection-table .table-header .th-label {
  text-align: left;
}

.inspection-table .table-row {
  display: grid;
  grid-template-columns: 48px 1fr minmax(120px, 1fr) 100px 100px;
  border-bottom: 1px solid #E8EAED;
  transition: background 0.1s;
}
.inspection-table .table-row:last-child {
  border-bottom: none;
}
.inspection-table .table-row:hover {
  background: #F8F9FA;
}
.inspection-table .table-row.not-applicable {
  opacity: 0.4;
}
.inspection-table .table-row > div {
  padding: 10px 8px;
  display: flex;
  align-items: center;
  border-right: 1px solid #F1F3F4;
}
.inspection-table .table-row > div:last-child {
  border-right: none;
}

.td-num {
  justify-content: center;
  font-size: 12px;
  color: #9AA0A6;
  font-weight: 700;
}

.td-label {
  flex-direction: column;
  align-items: flex-start !important;
}
.td-label span {
  font-size: 13px;
  color: #1F1F1F;
  font-weight: 600;
  display: block;
}
.td-label small {
  font-size: 11px;
  color: #9AA0A6;
  margin-top: 2px;
}

.td-opinion {
  flex-direction: column;
  align-items: flex-start !important;
  gap: 8px;
}
.td-opinion .opinion-text {
  font-size: 12px;
  color: #444746;
  word-break: break-word;
}

.td-repair {
  justify-content: center;
}

.repair-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px 12px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 700;
}
.repair-badge.repair-yes {
  background: #FEF7E0;
  color: #B05E00;
}
.repair-badge.repair-no {
  background: #E8F0FE;
  color: #1A73E8;
}

.repair-empty {
  font-size: 12px;
  color: #BDC1C6;
}

.td-grade {
  justify-content: center;
}

.grade-chip {
  padding: 4px 10px;
  border-radius: 8px;
  border: 1px solid #E0E0E0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 800;
  color: #E0E0E0;
  text-transform: uppercase;
}
.grade-chip.selected {
  color: #fff;
}
.grade-chip.selected[data-grade=a] {
  background: #1E8E3E;
  border-color: #1E8E3E;
}
.grade-chip.selected[data-grade=b] {
  background: #1A73E8;
  border-color: #1A73E8;
}
.grade-chip.selected[data-grade=c] {
  background: #F9AB00;
  border-color: #F9AB00;
}
.grade-chip.selected[data-grade=d] {
  background: #E8710A;
  border-color: #E8710A;
}
.grade-chip.selected[data-grade=e] {
  background: #D93025;
  border-color: #D93025;
}
.grade-chip.na-chip {
  background: #E8EAED;
  color: #1F1F1F;
  border-color: #C4C7C5;
  font-size: 11px;
  text-transform: none;
}
.grade-chip.empty {
  color: #BDC1C6;
  border: none;
}

.sports-table {
  width: 100%;
}

.sports-table .table-header {
  display: grid;
  grid-template-columns: 36px 1fr 60px 140px 60px;
  background: #F1F3F4;
  border-radius: 8px;
}
.sports-table .table-header > div {
  padding: 10px 8px;
  font-size: 12px;
  font-weight: 800;
  color: #3C4043;
  text-align: center;
}
.sports-table .table-header .th-label {
  text-align: left;
}

.sports-table .table-row {
  display: grid;
  grid-template-columns: 36px 1fr 60px 140px 60px;
}
.sports-table .table-row:hover {
  background: #F8F9FA;
}
.sports-table .table-row > div {
  padding: 10px 8px;
  display: flex;
  align-items: center;
}

.td-points {
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  color: #0B57D0;
}

.td-ratings {
  justify-content: center;
  display: flex;
  gap: 4px;
}

.rating-chip {
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  color: #BDC1C6;
  background: #F1F3F4;
}
.rating-chip.selected.good {
  background: #E6F4EA;
  color: #137333;
}
.rating-chip.selected.fair {
  background: #FEF7E0;
  color: #B05E00;
}
.rating-chip.selected.poor {
  background: #FCE8E6;
  color: #C5221F;
}

.td-score {
  justify-content: center;
  font-size: 13px;
  font-weight: 800;
  color: #1F1F1F;
}

.generic-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.generic-item {
  padding: 10px 12px;
  background: #F8F9FA;
  border-radius: 8px;
}
.generic-item .item-label {
  font-size: 13px;
  font-weight: 700;
  color: #1F1F1F;
  margin-bottom: 4px;
}
.generic-item .item-value {
  font-size: 13px;
  color: #444746;
}

.result-photo-section {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.result-photo-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 700;
  color: #5F6368;
}
.result-photo-title i {
  color: #0B57D0;
}

.result-photo-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.result-photo-thumb {
  width: 72px;
  height: 72px;
  border-radius: 10px;
  overflow: hidden;
  display: block;
  border: 1px solid #DADCE0;
  background: #E8EAED;
}
.result-photo-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.score-panel {
  flex-shrink: 0;
  background: #FFFFFF;
  border-top: 1px solid #E3E3E3;
  padding: 12px 16px;
  overflow-y: auto;
  max-height: 45vh;
}

.score-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 16px;
  background: #F8F9FA;
  border-radius: 12px;
  margin-bottom: 10px;
}

.score-main {
  display: flex;
  align-items: baseline;
  gap: 4px;
}
.score-main .score-label {
  font-size: 12px;
  color: #5F6368;
  font-weight: 700;
  margin-right: 4px;
}
.score-main .score-value {
  font-size: 28px;
  font-weight: 900;
  color: #1F1F1F;
}
.score-main .score-max {
  font-size: 14px;
  color: #9AA0A6;
  font-weight: 600;
}

.score-percent {
  font-size: 20px;
  font-weight: 800;
  color: #0B57D0;
}

.score-grade {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 900;
}
.score-grade[data-grade=A] {
  background: #E6F4EA;
}
.score-grade[data-grade=A] span {
  color: #137333;
}
.score-grade[data-grade=B] {
  background: #E8F0FE;
}
.score-grade[data-grade=B] span {
  color: #1A73E8;
}
.score-grade[data-grade=C] {
  background: #FEF7E0;
}
.score-grade[data-grade=C] span {
  color: #B05E00;
}
.score-grade[data-grade=D] {
  background: #FCE8E6;
}
.score-grade[data-grade=D] span {
  color: #E8710A;
}
.score-grade[data-grade=E] {
  background: #FCE8E6;
}
.score-grade[data-grade=E] span {
  color: #D93025;
}

.score-categories {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.score-categories .cat-item {
  display: flex;
  gap: 4px;
  align-items: center;
  padding: 4px 10px;
  background: #F1F3F4;
  border-radius: 6px;
  font-size: 12px;
}
.score-categories .cat-title {
  font-weight: 700;
  color: #1F1F1F;
}
.score-categories .cat-avg {
  font-weight: 800;
  color: #0B57D0;
}
.score-categories .cat-count {
  color: #9AA0A6;
}

.meta-section {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.meta-card {
  background: #FFFFFF;
  border: 1px solid #E8EAED;
  border-radius: 12px;
  overflow: hidden;
}

.meta-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #F8F9FA;
  border-bottom: 1px solid #E8EAED;
  font-size: 13px;
  font-weight: 800;
  color: #3C4043;
}
.meta-card-header i {
  color: #0B57D0;
  font-size: 13px;
}

.meta-card-body {
  padding: 12px 14px;
}

.meta-pair {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.meta-pair-item {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.meta-key {
  font-size: 11px;
  font-weight: 700;
  color: #5F6368;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.meta-val {
  font-size: 14px;
  color: #1F1F1F;
  font-weight: 600;
}

.meta-triple {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.meta-badge-item {
  flex: 1;
  min-width: 100px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.safety-grade-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  font-size: 18px;
  font-weight: 900;
}
.safety-grade-badge[data-grade=A] {
  background: #E6F4EA;
  color: #137333;
}
.safety-grade-badge[data-grade=B] {
  background: #E8F0FE;
  color: #1A73E8;
}
.safety-grade-badge[data-grade=C] {
  background: #FEF7E0;
  color: #B05E00;
}
.safety-grade-badge[data-grade=D] {
  background: #FCE8E6;
  color: #E8710A;
}
.safety-grade-badge[data-grade=E] {
  background: #FCE8E6;
  color: #D93025;
}

.meta-yn {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 700;
}
.meta-yn.yn-yes {
  background: #FCE8E6;
  color: #C5221F;
}
.meta-yn.yn-no {
  background: #F1F3F4;
  color: #5F6368;
}

.meta-opinion {
  font-size: 13px;
  color: #1F1F1F;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
}

.meta-timestamps {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 0 4px;
}
.meta-timestamps .ts-item {
  font-size: 11px;
  color: #9AA0A6;
  font-weight: 500;
}
.meta-timestamps .ts-item i {
  font-size: 10px;
}

.loader-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}
.loader-container p {
  margin-top: 16px;
  font-size: 14px;
  color: #5F6368;
  font-weight: 600;
}

.google-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #E8EAED;
  border-top-color: #0B57D0;
  border-radius: 50%;
  animation: spin 0.9s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 1024px) {
  .inspection-table .table-header, .inspection-table .table-row {
    grid-template-columns: 40px 1fr minmax(100px, 1fr) 80px 90px;
  }
}
@media (max-width: 768px) {
  .inspection-table .table-header, .inspection-table .table-row {
    grid-template-columns: 32px 1fr minmax(80px, 0.8fr) 70px 80px;
  }
  .meta-pair {
    grid-template-columns: 1fr;
  }
  .meta-triple {
    flex-direction: column;
  }
  .header-actions {
    flex-wrap: wrap;
  }
  .header-actions .btn-action span, .header-actions .btn-edit span {
    display: none;
  }
  .header-actions .btn-action, .header-actions .btn-edit {
    padding: 0 10px;
  }
}`],
})
export class PageChecklistResultComponent implements OnInit {
    public responseId: string = '';
    public response: any = null;
    public checklist: any = null;
    public facility: any = null;
    public project: any = null;
    public sections: any[] = [];
    public answers: any = {};
    public loading: boolean = true;

    // Inspection score
    public inspectionTotalScore: number = 0;
    public inspectionGrade: string = '';
    public inspectionCategories: any[] = [];

    // Sports score
    public sportsTotalScore: number = 0;
    public sportsMaxScore: number = 0;
    public sportsPercent: number = 0;
    public sportsGrade: string = '';

    // Active section
    public activeSectionIndex: number = 0;

    // Export / Share state
    public exporting: boolean = false;
    public sharing: boolean = false;
    public retryingSync: boolean = false;
    public offlineMissingItems: any[] = [];

    constructor(@Inject( Service)         public service: Service,@Inject( CDR    )         public ref: CDR    ) { }

    public async ngOnInit() {
        await this.service.init(this);
        this.responseId = WizRoute.segment.responseId || '';
        if (!this.responseId) {
            await this.service.href('/checklist');
            return;
        }
        await this.loadResult();
    }

    public async loadResult() {
        this.loading = true;
        await this.service.render();

        try {
            const { code, data, message } = await wiz.call("load_result", { response_id: this.responseId });
            if (code === 200) {
                this.response = data.response;
                this.checklist = data.checklist;
                this.facility = data.facility;
                this.project = data.project;
                this.sections = data.sections || [];
                this.answers = data.answers || {};
                this.computeScores();
                await this.recordChecklistPhotoManifest();
            } else {
                await this.service.alert.show({
                    title: '결과 캐시 누락',
                    message: message || data?.message || data || '체크리스트 결과 데이터를 불러올 수 없습니다.',
                    status: 'error',
                    action: '확인',
                });
            }
        } catch (e) {
            console.error(e);
            await this.service.alert.show({
                title: '결과 캐시 누락',
                message: '네트워크 없이 열 수 있는 체크리스트 결과 캐시가 없습니다.',
                status: 'error',
                action: '확인',
            });
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public getAnswer(itemId: string): any {
        return this.answers[itemId] || {};
    }

    public getAnswerPhotos(itemId: string): any[] {
        const answer = this.getAnswer(itemId);
        return Array.isArray(answer.photos) ? answer.photos : [];
    }

    // ====== Score computation (read-only) ======
    public computeScores() {
        if (!this.checklist) return;
        if (this.checklist.form_type === 'inspection') {
            this.computeInspectionScore();
        } else if (this.checklist.form_type === 'sports') {
            this.computeSportsScore();
        }
    }

    public computeInspectionScore() {
        const catMap = new Map<string, { sections: any[] }>();
        for (const section of this.sections) {
            const catTitle = section.group_title || section.title;
            if (!catMap.has(catTitle)) catMap.set(catTitle, { sections: [] });
            catMap.get(catTitle)!.sections.push(section);
        }

        const categories: any[] = [];
        for (const [title, data] of catMap.entries()) {
            let sum = 0, answered = 0, itemCount = 0, naCount = 0;
            for (const section of data.sections) {
                for (const item of (section.items || [])) {
                    itemCount++;
                    const answer = this.getAnswer(item.id);
                    if (answer.grade === 'na' || answer.not_applicable) { naCount++; continue; }
                    if (answer.grade && GRADE_VALUES[answer.grade] !== undefined) {
                        sum += GRADE_VALUES[answer.grade];
                        answered++;
                    }
                }
            }
            categories.push({
                title,
                weight: INSPECTION_CATEGORY_WEIGHTS[title] || 0,
                avg: answered > 0 ? Math.round((sum / answered) * 100) / 100 : 0,
                hasData: answered > 0,
                answeredCount: answered,
                totalCount: itemCount,
                naCount,
            });
        }

        this.inspectionCategories = categories;
        const active = categories.filter(c => c.hasData && c.weight > 0);
        const activeSum = active.reduce((s: number, c: any) => s + c.weight, 0);

        let totalScore = 0;
        if (activeSum > 0) {
            for (const cat of active) {
                totalScore += cat.avg * (cat.weight * (100 / activeSum)) / 100;
            }
        }
        this.inspectionTotalScore = Math.round(totalScore * 100) / 100;

        if (this.inspectionTotalScore >= 7) this.inspectionGrade = 'A';
        else if (this.inspectionTotalScore >= 6) this.inspectionGrade = 'B';
        else if (this.inspectionTotalScore >= 5) this.inspectionGrade = 'C';
        else if (this.inspectionTotalScore >= 4) this.inspectionGrade = 'D';
        else this.inspectionGrade = 'E';
    }

    public computeSportsScore() {
        let totalScore = 0;
        let maxScore = 0;

        for (const section of this.sections) {
            for (const item of (section.items || [])) {
                const points = item.points || 0;
                maxScore += points;
                const answer = this.getAnswer(item.id);
                if (answer.rating === 'good') {
                    totalScore += points * (section.good_multiplier ?? 1.0);
                } else if (answer.rating === 'fair') {
                    totalScore += points * (section.fair_multiplier ?? 0.6);
                } else if (answer.rating === 'poor') {
                    totalScore += points * (section.poor_multiplier ?? 0.4);
                }
            }
        }

        this.sportsTotalScore = Math.round(totalScore * 100) / 100;
        this.sportsMaxScore = maxScore;
        this.sportsPercent = maxScore > 0 ? Math.round((totalScore / maxScore) * 10000) / 100 : 0;

        if (this.sportsPercent >= 95) this.sportsGrade = 'A';
        else if (this.sportsPercent >= 85) this.sportsGrade = 'B';
        else if (this.sportsPercent >= 65) this.sportsGrade = 'C';
        else this.sportsGrade = 'D';
    }

    public getItemScore(item: any, section: any): number {
        const answer = this.getAnswer(item.id);
        const points = item.points || 0;
        if (answer.rating === 'good') return Math.round(points * (section.good_multiplier ?? 1.0) * 100) / 100;
        if (answer.rating === 'fair') return Math.round(points * (section.fair_multiplier ?? 0.6) * 100) / 100;
        if (answer.rating === 'poor') return Math.round(points * (section.poor_multiplier ?? 0.4) * 100) / 100;
        return 0;
    }

    public setActiveSection(idx: number) {
        this.activeSectionIndex = idx;
        this.service.render();
    }

    public getFormTypeLabel(): string {
        if (!this.checklist) return '';
        if (this.checklist.form_type === 'inspection') return '정기안전점검';
        if (this.checklist.form_type === 'sports') return '체육시설점검';
        return '일반 체크리스트';
    }

    public getGradeLabel(grade: string): string {
        const labels: any = { a: 'A (양호)', b: 'B (경미)', c: 'C (보통)', d: 'D (미흡)', e: 'E (불량)', na: '해당없음' };
        return labels[grade] || grade;
    }

    public getGradeColor(grade: string): string {
        const colors: any = { a: '#1E8E3E', b: '#1A73E8', c: '#F9AB00', d: '#E8710A', e: '#D93025', na: '#9AA0A6' };
        return colors[grade] || '#5F6368';
    }

    public getGradeDisplay(grade: string): string {
        if (grade === 'na') return '해당없음';
        return (grade || '-').toUpperCase();
    }

    public getRepairLabel(val: string): string {
        if (val === 'Y') return '유';
        if (val === 'N') return '무';
        return '-';
    }

    public getRatingLabel(rating: string): string {
        const labels: any = { good: '양호', fair: '보통', poor: '미흡' };
        return labels[rating] || '-';
    }

    public getStatusLabel(): string {
        if (!this.response) return '';
        if (this.response.status === 'submitted') return '제출 완료';
        if (this.response.status === 'submit_pending') return '제출 동기화 대기';
        if (this.response.status === 'sync_failed') return '제출 동기화 실패';
        if (this.response.status === 'draft') return '작성 중';
        return this.response.status;
    }

    public getStatusClass(): string {
        if (!this.response) return '';
        if (this.response.status === 'submit_pending') return 'submit-pending';
        if (this.response.status === 'sync_failed') return 'sync-failed';
        return this.response.status || 'draft';
    }

    public hasPhotoSyncFailure(): boolean {
        return this.response?.photo_sync_status === 'failed';
    }

    public isServerConfirmedResult(): boolean {
        return this.response?.status === 'submitted' && !this.hasPhotoSyncFailure();
    }

    public canExportServerResult(): boolean {
        return this.isServerConfirmedResult();
    }

    public canEditResponse(): boolean {
        return this.response?.status === 'draft' || this.response?.status === 'sync_failed';
    }

    public canRetrySync(): boolean {
        return this.response?.status === 'submit_pending' || this.response?.status === 'sync_failed';
    }

    public getRetrySyncLabel(): string {
        if (this.retryingSync) return '동기화 중';
        if (this.response?.status === 'sync_failed') return '다시 시도';
        return '지금 동기화';
    }

    public async retryChecklistSync() {
        if (!this.canRetrySync() || this.retryingSync) return;
        if (!wiz.offline || !wiz.offline.sync) {
            await this.service.alert.show({
                title: '동기화 재시도 불가',
                message: '오프라인 동기화 서비스를 사용할 수 없습니다.',
                status: 'error',
                action: '확인',
            });
            return;
        }

        this.retryingSync = true;
        await this.service.render();

        try {
            const sync = wiz.offline.sync;
            if (typeof sync.retryFailedItems === 'function') {
                await sync.retryFailedItems({
                    entity_type: 'checklist_response',
                    entity_id: this.responseId,
                    action: 'submit_response'
                });
            } else {
                await sync.syncAll();
            }
            await this.loadResult();
        } catch (error: any) {
            console.error('Checklist sync retry failed:', error);
            await this.service.alert.show({
                title: '동기화 재시도 실패',
                message: error?.message || '체크리스트 제출 동기화를 다시 시도할 수 없습니다.',
                status: 'error',
                action: '확인',
            });
        } finally {
            this.retryingSync = false;
            await this.service.render();
        }
    }

    public getExportSourceClass(): string {
        if (this.isServerConfirmedResult()) return 'server-confirmed';
        if (this.response?.status === 'sync_failed' || this.hasPhotoSyncFailure()) return 'local-failed';
        return 'local-pending';
    }

    public getExportSourceLabel(): string {
        if (this.isServerConfirmedResult()) return '서버 확정본';
        if (this.response?.status === 'sync_failed' || this.hasPhotoSyncFailure()) return '동기화 실패본';
        return '로컬 대기본';
    }

    public getExportSourceMessage(): string {
        if (this.isServerConfirmedResult()) {
            return '서버가 수락한 제출 데이터와 동기화된 사진 기준으로 export합니다.';
        }
        if (this.response?.status === 'sync_failed' || this.hasPhotoSyncFailure()) {
            const reason = this.response?.sync_error ? ` 사유: ${this.response.sync_error}` : '';
            return `서버 반영 또는 사진 파일 동기화가 실패해 서버 확정 export를 만들 수 없습니다.${reason}`;
        }
        if (this.response?.status === 'submit_pending') {
            return '오프라인 제출이 서버에 아직 반영되지 않았습니다. 온라인 복귀 후 동기화가 성공해야 서버 확정 export가 가능합니다.';
        }
        return '아직 서버 제출 완료 상태가 아니므로 export는 서버 확정본이 아닙니다.';
    }

    public formatDate(dateStr: string): string {
        if (!dateStr) return '-';
        try {
            const d = new Date(dateStr);
            return d.toLocaleDateString('ko-KR', { year: 'numeric', month: '2-digit', day: '2-digit' });
        } catch {
            return dateStr;
        }
    }

    public async goBack() {
        const projectId = this.project?.id || this.facility?.project_id;
        if (projectId) {
            await this.service.href(`/checklist/project/${projectId}`);
        } else {
            await this.service.href('/checklist');
        }
    }

    public async goToEdit() {
        await this.service.href(`/checklist/respond/${this.responseId}`);
    }

    // ====== HWPX Export ======
    public async exportHwpx() {
        if (this.exporting) return;
        this.exporting = true;
        await this.service.render();

        try {
            const result = await this.fetchHwpxBlob();
            if (!result) return;

            await this.downloadBlob(result.blob, result.filename);
        } catch (e: any) {
            console.error('HWPX export error:', e);
            await this.service.alert.show({
                title: '오류',
                message: e.message || '문서 생성 중 오류가 발생했습니다.',
                status: 'error',
                action: '확인',
            });
        } finally {
            this.exporting = false;
            await this.service.render();
        }
    }

    // ====== XLSX Export ======
    public async exportXlsx() {
        if (this.exporting) return;
        this.exporting = true;
        await this.service.render();

        try {
            const result = await this.fetchXlsxBlob();
            if (!result) return;

            await this.downloadBlob(result.blob, result.filename);
        } catch (e: any) {
            console.error('XLSX export error:', e);
            await this.service.alert.show({
                title: '오류',
                message: e.message || '엑셀 생성 중 오류가 발생했습니다.',
                status: 'error',
                action: '확인',
            });
        } finally {
            this.exporting = false;
            await this.service.render();
        }
    }

    // ====== Share ======
    public async shareResult() {
        if (this.sharing) return;
        this.sharing = true;
        await this.service.render();

        try {
            const isSports = this.checklist?.form_type === 'sports';
            const result = isSports ? await this.fetchXlsxBlob() : await this.fetchHwpxBlob();
            if (!result) return;

            const filename = result.filename;
            const file = new File([result.blob], filename, { type: 'application/octet-stream' });

            // Web Share API 시도 (navigator.share가 존재하면 바로 호출)
            if (navigator.share) {
                try {
                    await navigator.share({
                        files: [file],
                        title: `${this.checklist?.title || '체크리스트'} - 점검 결과`,
                        text: `${this.facility?.name || '시설물'} ${isSports ? '체육시설점검' : '정기안전점검'} 결과입니다.`,
                    });
                    return;
                } catch (shareErr: any) {
                    // 사용자 취소
                    if (shareErr.name === 'AbortError') return;
                    // 파일 공유 미지원 시 다운로드 폴백
                    console.warn('Web Share API failed, falling back to download:', shareErr);
                }
            }

            // 폴백: 파일 다운로드
            await this.downloadBlob(result.blob, filename);
        } catch (e: any) {
            console.error('Share error:', e);
            await this.service.alert.show({
                title: '오류',
                message: e.message || '공유 중 오류가 발생했습니다.',
                status: 'error',
                action: '확인',
            });
        } finally {
            this.sharing = false;
            await this.service.render();
        }
    }

    // ====== Private helpers ======
    private async fetchHwpxBlob(): Promise<ExportBlobResult | null> {
        return this.fetchExportBlob('hwpx', 'export_hwpx', this.getHwpxFilename(), '문서 생성에 실패했습니다.');
    }

    private async fetchXlsxBlob(): Promise<ExportBlobResult | null> {
        return this.fetchExportBlob('xlsx', 'export_xlsx', this.getXlsxFilename(), '엑셀 생성에 실패했습니다.');
    }

    private exportCacheId(kind: string): string {
        return `checklist_export_${kind}:${this.responseId}`;
    }

    private async cacheExportBlob(kind: string, blob: Blob, filename: string) {
        try {
            if (!wiz.offline || !wiz.offline.storage) return;
            await wiz.offline.storage.put('files', {
                id: this.exportCacheId(kind),
                type: `checklist_export_${kind}`,
                ref_id: this.responseId,
                filename,
                mime_type: blob.type || 'application/octet-stream',
                blob,
                server_confirmed: this.isServerConfirmedResult(),
                response_status: this.response?.status || '',
                cached_at: Date.now()
            });
            await this.recordCacheManifestItem({
                id: `export:${this.exportCacheId(kind)}`,
                category: 'export',
                label: `${this.facility?.name || '시설물'} ${this.checklist?.title || '체크리스트'} ${this.getExportSourceLabel()} ${kind.toUpperCase()} 추출본`,
                status: 'cached',
                required: false,
                ref_id: this.responseId,
                parent_id: this.facility?.id || '',
                filename,
                size: blob.size,
                error: '',
                cached_at: Date.now()
            });
        } catch (error) {
            console.warn('Checklist export cache write failed:', error);
        }
    }

    private async getCachedExportBlob(kind: string): Promise<{ blob: Blob; filename: string; serverConfirmed: boolean } | null> {
        try {
            if (!wiz.offline || !wiz.offline.storage) return null;
            const cached = await wiz.offline.storage.get('files', this.exportCacheId(kind));
            if (!cached || !cached.blob) return null;
            return {
                blob: cached.blob,
                filename: cached.filename || (kind === 'xlsx' ? this.getXlsxFilename() : this.getHwpxFilename()),
                serverConfirmed: cached.server_confirmed !== false
            };
        } catch (error) {
            console.warn('Checklist export cache read failed:', error);
            return null;
        }
    }

    private async fetchExportBlob(kind: string, action: string, filename: string, fallbackMessage: string): Promise<ExportBlobResult | null> {
        if (!this.canExportServerResult()) {
            await this.recordBlockedExportManifest(kind, filename);
            await this.service.alert.show({
                title: '서버 확정본 아님',
                message: this.getExportSourceMessage(),
                status: this.response?.status === 'sync_failed' || this.hasPhotoSyncFailure() ? 'error' : 'warning',
                action: '확인',
            });
            return null;
        }

        const formData = new FormData();
        formData.append('response_id', this.responseId);

        try {
            const response = await fetch(wiz.url(action), {
                method: 'POST',
                body: formData,
                credentials: 'include'
            });

            if (!response.ok) {
                let msg = fallbackMessage;
                try {
                    const err = await response.json();
                    msg = err.message || err.data || msg;
                } catch { }
                throw new Error(msg);
            }

            const blob = await response.blob();
            await this.cacheExportBlob(kind, blob, filename);
            return { blob, filename };
        } catch (error: any) {
            const cached = await this.getCachedExportBlob(kind);
            if (cached) {
                await this.service.alert.show({
                    title: cached.serverConfirmed ? '서버 확정본 캐시' : '로컬 대기본 캐시',
                    message: cached.serverConfirmed
                        ? '오프라인 상태라 마지막으로 생성된 서버 확정 export 캐시를 사용합니다.'
                        : '오프라인 상태라 마지막 로컬 대기 export 캐시를 사용합니다.',
                    status: 'warning',
                    action: '확인',
                });
                return { blob: cached.blob, filename: cached.filename };
            }

            await this.recordMissingExportManifest(kind, filename);
            const missingMessage = await this.buildOfflineExportMissingMessage(kind, fallbackMessage, error);
            await this.service.alert.show({
                title: '오류',
                message: missingMessage,
                status: 'error',
                action: '확인',
            });
            return null;
        }
    }

    private async recordCacheManifestItem(item: any) {
        try {
            const projectId = this.project?.id || this.facility?.project_id || '';
            if (!projectId || !wiz.offline?.storage?.updateCacheManifestItem) return;
            await wiz.offline.storage.updateCacheManifestItem(projectId, item);
        } catch (error) {
            console.warn('Checklist cache manifest update failed:', error);
        }
    }

    private getDataUrlSize(value: any): number {
        const data = String(value || '');
        if (!data) return 0;
        const commaIndex = data.indexOf(',');
        if (data.startsWith('data:') && commaIndex >= 0) {
            return Math.floor(data.slice(commaIndex + 1).length * 0.75);
        }
        return data.length;
    }

    private async recordChecklistPhotoManifest() {
        if (!this.answers || typeof this.answers !== 'object') return;
        for (const itemId of Object.keys(this.answers)) {
            const photos = Array.isArray(this.answers[itemId]?.photos) ? this.answers[itemId].photos : [];
            for (let index = 0; index < photos.length; index++) {
                const photo = photos[index];
                const photoId = photo?.id || `${itemId}:${index + 1}`;
                const status = this.getPhotoManifestStatus(photo);
                await this.recordCacheManifestItem({
                    id: `checklist_photo:${this.responseId}:${itemId}:${photoId}`,
                    category: 'checklist_photo',
                    label: photo?.name || `체크리스트 사진 ${index + 1}`,
                    status,
                    ref_id: photoId,
                    parent_id: this.responseId,
                    filename: photo?.name || '',
                    size: this.getDataUrlSize(photo?.data),
                    cached_at: photo?.data && status === 'cached' ? Date.now() : undefined,
                    error: this.getPhotoManifestError(status)
                });
            }
        }
    }

    private getPhotoManifestStatus(photo: any): string {
        if (!photo?.data) return 'missing';
        if (this.response?.status === 'sync_failed' || this.hasPhotoSyncFailure()) return 'failed';
        if (this.response?.status === 'submit_pending') return 'pending';
        return 'cached';
    }

    private getPhotoManifestError(status: string): string {
        if (status === 'missing') return '사진 데이터가 비어 있습니다.';
        if (status === 'failed') return this.response?.sync_error || '사진 파일 동기화에 실패했습니다.';
        if (status === 'pending') return '서버 사진 동기화 대기 중입니다.';
        return '';
    }

    private async recordBlockedExportManifest(kind: string, filename: string) {
        await this.recordCacheManifestItem({
            id: `export:${this.exportCacheId(kind)}`,
            category: 'export',
            label: `${this.facility?.name || '시설물'} ${this.checklist?.title || '체크리스트'} ${this.getExportSourceLabel()} ${kind.toUpperCase()} 추출본`,
            status: this.response?.status === 'sync_failed' || this.hasPhotoSyncFailure() ? 'failed' : 'pending',
            required: false,
            ref_id: this.responseId,
            parent_id: this.facility?.id || '',
            filename,
            error: this.getExportSourceMessage()
        });
    }

    private async recordMissingExportManifest(kind: string, filename: string) {
        await this.recordCacheManifestItem({
            id: `export:${this.exportCacheId(kind)}`,
            category: 'export',
            label: `${this.facility?.name || '시설물'} ${this.checklist?.title || '체크리스트'} 마지막 ${kind.toUpperCase()} 추출본`,
            status: 'missing',
            required: false,
            ref_id: this.responseId,
            parent_id: this.facility?.id || '',
            filename,
            error: '온라인에서 한 번 추출해야 오프라인 export를 사용할 수 있습니다.'
        });
    }

    private async buildOfflineExportMissingMessage(kind: string, fallbackMessage: string, error: any): Promise<string> {
        const baseMessage = error?.message && error.message !== 'Failed to fetch'
            ? error.message
            : `${fallbackMessage} 온라인에서 한 번 추출한 뒤 오프라인 캐시 추출을 사용할 수 있습니다.`;

        try {
            const projectId = this.project?.id || this.facility?.project_id || '';
            if (!projectId || !wiz.offline?.prefetch) return baseMessage;
            const items = await wiz.offline.prefetch.getMissingItems(projectId, ['export', 'checklist_photo']);
            const relevant = (items || []).filter((item: any) =>
                item.ref_id === this.responseId || item.parent_id === this.responseId || String(item.id || '').includes(this.responseId)
            );
            if (relevant.length === 0) return baseMessage;
            const list = relevant.slice(0, 5).map((item: any) => `- ${item.label || item.filename || item.ref_id}`).join('\n');
            return `${baseMessage}\n\n부족한 파일:\n${list}`;
        } catch {
            return baseMessage;
        }
    }

    private getHwpxFilename(): string {
        const projectName = this.project?.title || '프로젝트';
        const facilityName = this.facility?.name || '시설물';
        const checklistName = this.checklist?.title || '체크리스트';
        const inspectorName = this.response?.inspector_name || '';
        const inspDate = this.response?.inspection_date
            ? String(this.response.inspection_date).substring(0, 10).replace(/-/g, '.')
            : '';
        return `${projectName}_${facilityName}_${checklistName}_${inspectorName}_${inspDate}.zip`;
    }

    private getXlsxFilename(): string {
        const projectName = this.project?.title || '프로젝트';
        const facilityName = this.facility?.name || '시설물';
        const checklistName = this.checklist?.title || '체크리스트';
        const inspectorName = this.response?.inspector_name || '';
        const inspDate = this.response?.inspection_date
            ? String(this.response.inspection_date).substring(0, 10).replace(/-/g, '.')
            : '';
        return `${projectName}_${facilityName}_${checklistName}_${inspectorName}_${inspDate}.zip`;
    }

    private isCapacitor(): boolean {
        return typeof window !== 'undefined'
            && !!(window as any).Capacitor
            && (window as any).Capacitor.isNativePlatform
            && (window as any).Capacitor.isNativePlatform();
    }

    private async downloadBlob(blob: Blob, filename: string) {
        if (this.isCapacitor()) {
            const { Filesystem, Directory } = await import('@capacitor/filesystem');
            const arrayBuffer = await blob.arrayBuffer();
            const uint8 = new Uint8Array(arrayBuffer);
            let binary = '';
            const chunkSize = 8192;
            for (let i = 0; i < uint8.length; i += chunkSize) {
                binary += String.fromCharCode.apply(null, Array.from(uint8.subarray(i, i + chunkSize)));
            }
            const base64 = btoa(binary);

            try {
                const permissions = await Filesystem.checkPermissions();
                if (permissions.publicStorage !== 'granted') {
                    await Filesystem.requestPermissions();
                }
            } catch {}

            const path = `inspectPRO/${filename}`;
            const attempts = [
                { directory: Directory.Documents, label: 'Downloads/inspectPRO' },
                { directory: Directory.External, label: '앱 저장소/inspectPRO' }
            ];

            let savedLabel = '';
            let savedUri = '';
            let lastError: any = null;
            for (const attempt of attempts) {
                try {
                    await Filesystem.writeFile({
                        path,
                        data: base64,
                        directory: attempt.directory,
                        recursive: true
                    });
                    const uriResult = await Filesystem.getUri({
                        path,
                        directory: attempt.directory
                    });
                    savedLabel = attempt.label;
                    savedUri = uriResult.uri || '';
                    lastError = null;
                    break;
                } catch (error) {
                    lastError = error;
                }
            }

            if (lastError) {
                throw new Error(lastError?.message || '파일 저장에 실패했습니다.');
            }

            await this.service.alert.show({
                title: '저장 완료',
                message: `${savedLabel} 폴더에 저장되었습니다.\n파일명: ${filename}${savedUri ? `\n위치: ${savedUri}` : ''}`,
                status: 'success',
                action: '확인',
            });
        } else {
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        }
    }
}

export default PageChecklistResultComponent;